import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/** Shared input for the three Discount Rescue analytics RPCs. */
export const discountRescueInput = z.object({
  dateRange: z
    .object({ start: zExt.plainDate(), end: zExt.plainDate() })
    .optional(),
});
